import { Box, ListItem, Tooltip } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Lock, Report } from "@material-ui/icons";
import { CreditScoreOutlined, MeetingRoomOutlined } from "@mui/icons-material";
import moment from "moment";
import { Currency } from "../../../../components/misc/Currency";
import { useI18n } from "../../../../hooks/useI18n";
import { UserStatus } from "../../../../models/User";
import { UserEvent as UserEventProps } from "../../types";
import useStyles from "./styles";

const formattedPurchaseAmount = (amount: number) => {
  if (amount <= 0) {
    return "-";
  }
  return <Currency value={Math.round(amount * 100) / 100} />;
};
export const UserEvent = (event: UserEventProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useI18n();

  const tooltipText: any = {
    OpenDoor: t("common.messages.entered"),
    Payment: t("common.messages.madePayment")
  };

  let animation = "";
  if (event.changeType === "added" || event.changeType === "modified") {
    animation =
      event.event === "OpenDoor" ? classes.openDoor : classes.purchase;
  }

  return (
    <ListItem
      key={event.user.id}
      button
      onClick={() => event.onClick(event.user.id)}
      className={animation}
      style={{ display: "flex", marginBottom: 1 }}
    >
      <span className={classes.eventType}>
        <Tooltip title={`${tooltipText[event.event]} - ${event.storeName}`}>
          {event.event === "OpenDoor" ? (
            <MeetingRoomOutlined />
          ) : (
            <CreditScoreOutlined className={"eventPayment"} />
          )}
        </Tooltip>
      </span>
      <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingBottom: "0.2rem"
          }}
        >
          <span className={`${classes.user} ${classes.value}`}>
            {event.user.firstName} {event.user.lastName}{" "}
            {event.user.status === UserStatus.Suspicious ? (
              <Report className={classes.userSuspicious} />
            ) : event.user.status === UserStatus.Locked ? (
              <Lock className={classes.userLocked} />
            ) : (
              <></>
            )}
          </span>
          <span className={classes.hour}>
            <Tooltip title={"Time"}>
              <span>{moment(event.timestamp).format("HH:mm")}</span>
            </Tooltip>
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "end" }}>
          <Tooltip
            title={`Latest purchase (incl. VAT). Registered ${moment(
              event.timestamp
            ).format("HH:mm")}`}
          >
            <span
              className={`${classes.lastPurchase} ${classes.value} ${classes.purchaseAmount}`}
            >
              {formattedPurchaseAmount(
                event.user.purchaseOverview.latestInclVat
              )}
            </span>
          </Tooltip>
        </div>
      </Box>
    </ListItem>
  );
};
